import React from "react";
import axios from "axios";
import { image } from "../../helpers";
import Creators from "./Creators";
import Genres from "./Genres";
import { ArrowLeft } from "react-feather";

const Media = WrappedComponent => {
  return class Media extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        id: 0,
        media: {},
        media_type: this.getMediaType(),
        error: null
      };
    }

    getMediaType() {
      return this.props.match.url.split("/")[1];
    }

    fetch = _ => {
      let param_id = this.props.match.params.id;
      let media_type = this.getMediaType();

      if (this.state.media_type !== media_type)
        this.setState({ media_type: media_type });

      if (param_id && this.state.id !== param_id) {
        axios
          .get(`${media_type}/${this.props.match.params.id}`)
          .then(response => {
            this.setState({ id: param_id, media: response.data });
          });
      }
    };

    componentDidMount() {
      this.fetch();
    }

    componentDidUpdate() {
      this.fetch();
    }

    render() {
      const { media } = this.state;

      if (!media) {
        return <div>Loading...</div>;
      }

      return (
        <div className="sm:flex">
          <div className="sm:w-1/3 justify-center sm:mr-4 mr-0">
            {(this.state.media.backdrop_path ||
              this.state.media.profile_path) && (
              <img
                className="rounded border-b-2 shadow mb-4"
                src={image({
                  image: this.state.media,
                  type: this.state.media_type
                })}
                alt=""
              />
            )}

            <Creators {...media} />
            <Genres {...media} />
          </div>

          <div className="sm:w-full">
            <button
              className="shadow hover:shadow-md transition hover:text-blue-light text-grey-dark py-2 px-4 mb-4 rounded-full inline-flex items-center float-right focus:outline-none"
              onClick={() => this.props.history.goBack()}
            >
              <ArrowLeft size={16} />&nbsp;Back
            </button>

            <div className="text-3xl font-thin leading-normal text-grey-darkest cursor-default truncate">
              {this.state.media.name || this.state.media.title}
            </div>

            <WrappedComponent {...this.state} {...this.props} />
          </div>
        </div>
      );
    }
  };
};

export default Media;



// WEBPACK FOOTER //
// ./src/components/Media/Media.js